import React from "react";
import "./about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component

const Logo = () => {
  return (
    <div className="about-education">
      <Header />
      <main className="content">
        <section className="hero">
          <img
            src="Images/About/header.png"
            alt="Background"
            className="hero-image"
          />
          <div className="overlay">
           <h1 className="title">Logo</h1>
          </div>
        </section>

        <section className="text-content">
          <div style={{ textAlign: "center" }}>
            <img
              src="Images/LOGO.png"
              alt="Logo Image"
              style={{ display: "block", margin: "0 auto", maxWidth: "100%", height: "150px", padding: "20px" }}
            />
          </div>

          <p>
            <center>
              The logo of JAMIA NIDA-E-ISLAM ISLAMIC SCHOOL is not just a visual symbol—it represents the essence of the school’s vision and purpose. At its heart lies an open book, a universal emblem of learning and knowledge. From the book rises a radiant flame, signifying enlightenment and the transformative power of education. This imagery aligns seamlessly with the school’s profound belief, encapsulated in its slogan, “Knowledge is Light.” The flame is a reminder of how education can illuminate lives, dispelling ignorance and guiding students toward a brighter future.<br/><br/>

              Framing the book are laurel branches, gracefully positioned to symbolize growth, achievement, and the nurturing environment that the school fosters for every student. These elements come together to reflect the harmonious balance between academic excellence and personal development—a cornerstone of JAMIA NIDA-E-ISLAM’s philosophy.<br/><br/>

              The bold circular border, inscribed with the school’s name, anchors the logo and reinforces its identity as an Islamic institution committed to education grounded in strong moral values. The stars at the edges evoke aspirations for excellence and highlight the institution’s mission to inspire students to aim high and realize their full potential.<br/><br/>

              Together, the design elements of the logo are a thoughtful representation of the school’s unwavering commitment to cultivating knowledge, character, and a sense of purpose in its students. It is more than an image—it’s a story of enlightenment, growth, and the belief that education can change lives and build better communities.
            </center>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Logo;
